interface ISpinnerProps {
  size?: number;
  thickness?: number;
  colorMode?: "light" | "dark";
  fullScreenHeight?: boolean;
}

export function Spinner({
  size = 30,
  thickness = 4,
  colorMode = "light",
  fullScreenHeight = false,
}: ISpinnerProps) {
  const colorClass =
    colorMode === "light"
      ? `border-gray-100 border-t-teal-300`
      : `border-gray-300 border-t-teal-600`;

  return (
    <div className={`${fullScreenHeight ? "h-screen" : "h-full"} flex items-center justify-center`}>
      <div
        style={{ width: size, height: size, borderWidth: thickness }}
        className={`animate-spin rounded-full border-solid ${colorClass}`}
      />
    </div>
  );
}
